import { Grid, Paper, Typography } from '@mui/material';
import React from 'react';

import { useTaxonomy } from 'app/hooks/use-taxonomy';

import { Brand } from 'app/model/cris/brand';

interface BrandDetailViewProps {
    brand: Brand;
}

export const BrandDetailView: React.FunctionComponent<BrandDetailViewProps> = ({ brand }) => {
    const { currencySymbol } = useTaxonomy();

    return (
        <Paper elevation={3} className='p-2'>
            <Typography variant='h5'>Brand Details</Typography>
            <Grid container>
                <Grid item xs={4}>
                    <Typography>
                        <strong>Name</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    {brand.name}
                </Grid>

                <Grid item xs={4}>
                    <Typography>
                        <strong>Category</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    {brand.category?.category}
                </Grid>

                <Grid item xs={4}>
                    <Typography>
                        <strong>Mid Count</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    {brand.midCount?.toLocaleString()}
                </Grid>

                <Grid item xs={12}>
                    <Typography variant='h5'>Spend Info</Typography>
                </Grid>

                <Grid item xs={4}>
                    <Typography>
                        <strong>Spend</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    {currencySymbol}
                    {Number(brand.spendInfo?.spend).toLocaleString()}
                </Grid>

                <Grid item xs={4}>
                    <Typography>
                        <strong>Trx Count</strong>
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    {Number(brand.spendInfo?.trxCount).toLocaleString()}
                </Grid>
            </Grid>
        </Paper>
    );
};
